export const logoWhite =
  "https://customer-assets.emergentagent.com/job_leadership-mandate/artifacts/v7k485pb_White%20logo%20-%20no%20background.png";

export const navLinks = [
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Sectors", path: "/sectors" },
  { label: "Expertise", path: "/expertise" },
  { label: "Insights", path: "/insights" },
  { label: "Contact", path: "/contact" },
];

export const services = [
  {
    slug: "executive-search",
    number: "01",
    title: "Executive Search",
    brief:
      "C-suite, VP, and senior director appointments in roles where the candidate pool is small and highly networked.",
    image:
      "/images/sector-hero.webp",
    description:
      "We conduct executive searches for C-suite, VP, and senior director roles across energy, semiconductor, and industrial businesses in Asia. We typically work on roles where the candidate pool is small, highly networked, and unlikely to respond to a job posting — VPs of fab operations for semiconductor manufacturers, country GMs for energy companies, supply chain leaders for industrial platforms.",
    expandedParagraph:
      "Our process is thorough but not slow. A typical search takes 8-12 weeks from mandate to shortlist. We present 3-5 candidates, each one personally assessed by the lead principal — not screened by an algorithm.",
  },
  {
    slug: "axis-mscore",
    number: "02",
    title: "AXIS Mscore\u2122",
    brief:
      "A structured leadership evaluation framework for objective hiring and succession decisions within industrial organisations.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/9ff9841b-820b-424f-b5fd-4417d5f9a69f/images/aa888368aa405834238fc3805865d1dd88ad611ff6eedee89b46d3e1944c8bb0.png",
    description:
      "AXIS Mscore\u2122 is Axentia Global\u2019s structured leadership evaluation framework, designed to support objective hiring and succession decisions within industrial organisations. The model integrates functional depth, leadership capability, strategic alignment, and motivational drivers into a clear, comparative assessment.",
    expandedParagraph:
      "Rather than relying on instinct or unstructured interviews, AXIS Mscore\u2122 gives hiring committees and boards a consistent lens through which to evaluate candidates \u2014 whether for a new appointment or an internal succession decision. Each candidate is assessed across dimensions that matter in industrial leadership: depth of sector-specific knowledge, ability to lead across cultures and geographies, alignment with the organisation\u2019s strategic direction, and the personal motivations that determine long-term fit and retention.",
  },
  {
    slug: "axis-marketgrid",
    number: "03",
    title: "AXIS MarketGrid\u2122",
    brief:
      "Competitor leadership mapping, compensation benchmarking, and talent availability assessment across defined industrial ecosystems.",
    image:
      "/images/expertise-hero.webp",
    description:
      "Beyond active hiring, AXIS MarketGrid\u2122 maps competitor leadership structures, benchmarks compensation, and assesses talent availability across defined industrial ecosystems. This enables informed decision-making around succession, expansion, and capability building.",
    expandedParagraph:
      "AXIS MarketGrid\u2122 engagements are particularly valuable during market entry \u2014 understanding which leaders run key competitors in a new geography \u2014 post-M&A integration, organisational restructuring, and proactive succession planning. The output is a structured talent landscape that gives leadership teams the data to make strategic people decisions, not reactive ones.",
  },
];

export const practices = [
  {
    slug: "value-chain-leadership",
    name: "Value Chain Leadership",
    leader: "Rushit Shah",
    leaderPath: "/leadership",
    details:
      "Sales & Commercial, Supply Chain & Logistics, Manufacturing & Operations, Procurement & Sourcing, R&D, Technology & Digital, Information Technology",
  },
  {
    slug: "finance-corporate",
    name: "Finance & Corporate",
    leader: "Rushit Shah",
    leaderPath: "/leadership",
    details:
      "CFO & Finance Leadership, Treasury, Corporate Development, M&A, Investor Relations",
  },
  {
    slug: "human-resources",
    name: "Human Resources",
    leader: "Rushit Shah",
    leaderPath: "/leadership",
    details:
      "CHRO & HR Leadership, Talent Management, Organisational Development, Total Rewards, HR Transformation",
  },
  {
    slug: "information-cybersecurity",
    name: "Information & Cybersecurity",
    leader: "Rushit Shah",
    leaderPath: "/leadership",
    details:
      "CISO & Security Leadership, Information Security, OT/ICS Security, Cloud & Infrastructure Security, GRC, Data Protection & Privacy, Security Architecture",
  },
];

export const sectors = [
  {
    slug: "semiconductor",
    title: "Semiconductor & Advanced Manufacturing",
    details:
      "Fab operations, packaging & test, equipment OEMs, EDA, advanced materials",
    image:
      "https://customer-assets.emergentagent.com/job_19cdfdb8-e769-4653-8360-41b2fa6dceaf/artifacts/qlt6qayt_Semiconductor%20Industry%20Image%203.png",
  },
  {
    slug: "oil-gas",
    title: "Oil & Gas",
    details: "Upstream, midstream, downstream, LNG, refining",
    image:
      "https://customer-assets.emergentagent.com/job_19cdfdb8-e769-4653-8360-41b2fa6dceaf/artifacts/tx94jf3v_Oil%20and%20Gas%20Industry%20Image%201.png",
  },
  {
    slug: "renewables",
    title: "Renewables",
    details: "Solar, wind, hydrogen, energy storage, green finance",
    image:
      "https://customer-assets.emergentagent.com/job_19cdfdb8-e769-4653-8360-41b2fa6dceaf/artifacts/gbteijy4_Renewable%20Energy%20Image%201.png",
  },
  {
    slug: "automotive-aviation",
    title: "Automotive & Aviation",
    details: "OEM leadership, EV & battery technology, MRO operations, aerospace supply chain, propulsion systems",
    image:
      "https://customer-assets.emergentagent.com/job_9ff9841b-820b-424f-b5fd-4417d5f9a69f/artifacts/4c93vrpl_Automotive%20Industry%20Image%203.png",
  },
  {
    slug: "industrial",
    title: "Industrials",
    details: "Manufacturing, chemicals, engineering, EPC",
    image:
      "https://customer-assets.emergentagent.com/job_19cdfdb8-e769-4653-8360-41b2fa6dceaf/artifacts/tyy3eugt_Gemini_Generated_Image_2snzuw2snzuw2snz.png",
  },
  {
    slug: "life-sciences",
    title: "Life Sciences & Healthcare Manufacturing",
    details: "Pharmaceuticals, Biotechnology, Medical Devices, Diagnostics, Contract Manufacturing (CDMO/CMO)",
    image:
      "https://static.prod-images.emergentagent.com/jobs/d99b2d94-a9f9-4547-b27c-819ca14cc2ff/images/97a508109f4fa769f9b0a53030643fd6537be63ee631651476ab2963254bfa47.jpeg",
  },
];

export const leaders = [
  {
    initials: "RS",
    name: "Rushit Shah",
    photo: "https://customer-assets.emergentagent.com/job_e3c84ad5-239f-4120-8253-4e4200bd0957/artifacts/knqeagmg_Screenshot%202025-07-12%20at%202.22.22%E2%80%AFAM.png",
    email: "rs@axentiaglobal.com",
    linkedin: "https://www.linkedin.com/in/rushitshah/",
    title: "Managing Partner",
    careerSummary: "Rushit has spent over a decade advising energy, semiconductor, and industrial organisations across Asia on senior leadership appointments across operations, supply chain, commercial, technology, and human resources functions.",
    bio: "Rushit advises energy, semiconductor, and industrial clients on leadership appointments across operations, supply chain, commercial, procurement, human resources, and technology functions \u2014 including CIO and IT leadership. His practice draws on years spent working within the energy value chain, which gives him a practitioner\u2019s understanding of what these roles actually require in an Asian operating context.",
    expandedBio: "Prior to founding Axentia Global, Rushit held operating and advisory roles across the energy and industrial value chain in Asia. He works closely with clients in oil & gas, petrochemicals, renewables, semiconductor manufacturing, and industrial businesses to identify leaders who can deliver in complex, multi-market operating environments. His searches span VP through C-suite appointments across operations, supply chain, commercial, finance, human resources, and technology functions \u2014 from Chief Operating Officers to CHROs and Chief Information Officers.",
    tags: ["Value Chain", "Operations", "Human Resources", "CIO / IT"],
  },
];

export const markets = [
  { market: "Singapore", detail: "Energy majors, semiconductor ecosystem, regional HQs" },
  { market: "Thailand", detail: "Petrochemicals, power generation, industrial conglomerates" },
  { market: "India", detail: "Renewables, refining, manufacturing, infrastructure" },
  { market: "Malaysia", detail: "National oil company ecosystem, LNG, downstream" },
  { market: "Hong Kong", detail: "Financial services, regional governance, industrial groups" },
  { market: "Indonesia", detail: "Mining, upstream energy, industrial infrastructure" },
];

// Articles are now served from the CMS API - no static data needed
export const insightsArticles = [];

export const slugFromTitle = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
